import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { JudgePhaseProjectType } from "../../../types/ScientificModule";

const initialState: JudgePhaseProjectType = {
    id: "",
    comments: "",
    idJudge: "",
    idPhase: "",
    idProject: "",
    status: false,
};

const judgePhaseProjectsSlice = createSlice({
    name: "judgePhaseProjects",
    initialState,
    reducers: {
        setJudgePhaseProjectsData: (state, action: PayloadAction<JudgePhaseProjectType>) => ({ ...state, ...action.payload }),
        resetJudgePhaseProjectsData: () => ({ ...initialState }),
    },
});

export const { setJudgePhaseProjectsData, resetJudgePhaseProjectsData } = judgePhaseProjectsSlice.actions;

export default judgePhaseProjectsSlice.reducer;
